import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './app/App';
import PublicApp from './app/PublicApp';
import axios from "axios";

import AppConfigProvider from "./app/context/provider";
import { AuthProvider } from "./auth";
import { ThemeProvider } from '@mui/material';
import {theme} from "./app/theme/maintheme"

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

async function getTenant() {
  const tenant: string = window.location.hostname.split(".")[0];
  return { tenantId: tenant };
}

async function getConfig() {
  const { data } = await axios.get(`${process.env.PUBLIC_URL}/config.json`);
  return data;
}

/**
 *
 * @param keycloakProxyUrl baseUrl of keycloak proxy (ex: https://auth.proxy.[dms-domain]/auth)
 * @param realmId identifier of keycloak realm (e.g. tenant / realm ID)
 * @returns baseUrl of keycloak instance (ex: https://auth.[dms-domain]/auth)
 */
async function getKeycloakInstanceUrl(keycloakProxyUrl: string, realmId: string) {
  let oidcDiscoveryEndpoint;
  if (keycloakProxyUrl.charAt(keycloakProxyUrl.length - 1) == '/') {
    oidcDiscoveryEndpoint = keycloakProxyUrl + '.well-known/openid-configuration'
    oidcDiscoveryEndpoint = `${keycloakProxyUrl}realms/${realmId}/.well-known/openid-configuration`
  } else {
    oidcDiscoveryEndpoint = `${keycloakProxyUrl}/realms/${realmId}/.well-known/openid-configuration`
  }
  try {
    // get keycloak instance url through oidc discovery / well-known endpoint
    const { data } = await axios.get(oidcDiscoveryEndpoint)
    // truncate /realms route
    return data.issuer.substring(0, data.issuer.indexOf('realms'))
  } catch (error) {
    console.error(`failed to discover keycloak instance url, fallback to input url [${keycloakProxyUrl}]`);
    return keycloakProxyUrl
  }
}

(async () => {
  const { baseUrl, baseAppUrl , baseDeviceUrl, authServerUrl, clientId, configBrand, productCode, appRegionId, baseStorageUrl } = await getConfig();
  const path = window.location.pathname.split("/")[1];
  const publicPath : boolean = path === 'public';
  let { tenantId } = await getTenant();
  const kcInstanceUrl = publicPath ? "" : await getKeycloakInstanceUrl(authServerUrl, tenantId);

  root.render(
    <AppConfigProvider baseUrl={baseUrl} baseAppUrl={baseAppUrl} baseDeviceUrl={baseDeviceUrl} baseStorageUrl={baseStorageUrl}
      tenantId={tenantId} configBrand={configBrand} productCode={productCode} 
      appRegionId={appRegionId}
    >
      { publicPath ? 
        <ThemeProvider theme = {theme}>
          <PublicApp />
        </ThemeProvider>
        :
        <AuthProvider
          authServerUrl={kcInstanceUrl}
          tenantId={tenantId}
          clientId={clientId}
        >
          <ThemeProvider theme = {theme}>  
            <App />
          </ThemeProvider>
        </AuthProvider>
      }
    </AppConfigProvider>   
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
